export function minLengthArray(min) {
    return (c) => {
        if (c?.value?.length >= min)
            return null;
        return { minLengthArray: { valid: false } };
    };
}
